import Dropzone from "dropzone";

export default () => {

    /*FORM VALIDATION*/

    let applicationForm = document.querySelector('.application-form');
    let formInputs = applicationForm.querySelectorAll('input');
    let requiredInputs = applicationForm.querySelectorAll('[data-required=true]');
    let phoneInput = applicationForm.querySelector('[name=phone]');
    let emailInput = applicationForm.querySelector('[name=email]');
    let cvInput = applicationForm.querySelector('[name=cv]');
    let linkedInInput = applicationForm.querySelector('[name=linkedIn]');
    let cvInputInner = document.querySelector('.label-cv-inner');
    let cvInputInnerHTML = cvInputInner.innerHTML;
    let checkboxInput = applicationForm.querySelector('[name=terms]');
    let emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    let phonePattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    let validationStatus = true;
    let requiredMessage = document.getElementById('message_required').innerText;
    let formatMessage = document.getElementById('message_format').innerText;
    let allowedTypesMessage = document.getElementById('message_allowedTypes').innerText;
    let errorMessages = {
        required: requiredMessage,
        format: formatMessage,
        allowedTypes: allowedTypesMessage,
    };

    applicationForm.addEventListener('submit', (e) => {
        validationStatus = true;
        e.preventDefault();
        formValidation();
        if (validationStatus) {
            applicationFormSend();
        }
    });

    formInputs.forEach((input) => {
        input.addEventListener('change', function () {
            let inputWrap = input.closest('.input-wrapper');
            if (inputWrap && inputWrap.classList.contains('error')) {
                formValidation();
            }
        });
    });

    cvInput.addEventListener('change', function () {
        if (cvInput.classList.contains('error')) {
            formValidation();
        }
    });

    linkedInInput.addEventListener('change', function () {
        if (linkedInInput.classList.contains('error')) {
            checkLinkedInOrCV();
        }
    });

    function formValidation() {
        checkRequiredInputs();
        checkValue(emailInput, emailPattern, errorMessages.format);
        checkValue(phoneInput, phonePattern, errorMessages.format);
        checkCVFile();
        checkCheckbox();
        checkLinkedInOrCV();
    }

    cvInput.addEventListener('change', function () {
        fileInputProgressBar();
    });

    function checkLinkedInOrCV() {
        let errorMessage = document.getElementById('errorTextCV');
        if ((!cvInput.value && !linkedInInput.value) || (cvInput.value === '' && linkedInInput.value === '')) {
            errorMessage.classList.add('error');
            cvInput.classList.add('error');
            linkedInInput.classList.add('error');
            validationStatus = false;
        } else {
            errorMessage.classList.remove('error');
            cvInput.classList.remove('error');
            linkedInInput.classList.remove('error');
        }
    }

    function checkRequiredInputs() {
        requiredInputs.forEach((item) => {
            let currentWrap = item.closest('.input-wrapper');
            let currentErrorMessage = currentWrap.querySelector('.error-msg');
            if (!item.value || item.value === '') {
                validationStatus = false;
                currentWrap.classList.add('error');
                currentErrorMessage.innerText = errorMessages.required;
            } else {
                currentWrap.classList.remove('error');
            }
        });
    }

    function checkValue(input, pattern, errorMessage) {
        let currentWrap = input.closest('.input-wrapper');
        let currentErrorMessage = currentWrap.querySelector('.error-msg');
        if (input.value && !(pattern.test(input.value))) {
            validationStatus = false;
            currentWrap.classList.add('error');
            currentErrorMessage.innerText = errorMessage;
        } else if (input.value && input.value !== '') {
            currentWrap.classList.remove('error');
        }
    }

    function checkCVFile() {
        let typeStatus = false;
        let sizeLimitMb = 20;
        let typesArr = [
            'text/plain',
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        let label = document.querySelector('.label-cv');
        let formatBlocks = document.querySelectorAll('.format-block');
        let progressBar = document.getElementById('progressBar');
        let file = cvInput.files[0];
        if (file) {
            let fileName = file.name;
            let fileSize = file.size / 1000000;
            let fileType = file.type;
            typesArr.forEach((allowedType) => {
                if (fileType === allowedType) {
                    typeStatus = true;
                }
            });
            if (fileSize > sizeLimitMb) {
                validationStatus = false;
                errorStatusForCV();
            } else if (!typeStatus) {
                validationStatus = false;
                errorStatusForCV();
            } else {
                successStatusForCV();
                cvInputInner.innerHTML = fileName;
            }
        }

        function errorStatusForCV() {
            formatBlocks.forEach((item) => {
                item.classList.add('error');
            });
            progressBar.style.width = 0;
            label.classList.add('error');
            cvInputInner.innerHTML = cvInputInnerHTML;
            cvInput.value = '';
        }

        function successStatusForCV() {
            formatBlocks.forEach((item) => {
                item.classList.remove('error');
            });
            label.classList.remove('error');
        }

    }

    function checkCheckbox() {
        let currentWrap = checkboxInput.closest('.input-wrapper');
        let currentErrorMessage = currentWrap.querySelector('.error-msg');
        if (checkboxInput.checked !== true) {
            validationStatus = false;
            currentWrap.classList.add('error');
            currentErrorMessage.innerText = errorMessages.required;
        } else {
            currentWrap.classList.remove('error');
        }
    }

    /*FILE INPUT PROGRESS BAR*/

    function fileInputProgressBar() {
        function uploadFile() {
            var file = document.getElementById("cv").files[0];
            if (file) {
                var formdata = new FormData();
                formdata.append("cv", file);
                var ajax = new XMLHttpRequest();
                ajax.upload.addEventListener("progress", progressHandler, false);
                ajax.addEventListener("load", completeHandler, false);
                ajax.addEventListener("error", errorHandler, false);
                ajax.addEventListener("abort", abortHandler, false);
                ajax.open("POST", "/api/file_upload_parser.php"); // http://www.developphp.com/video/JavaScript/File-Upload-Progress-Bar-Meter-Tutorial-Ajax-PHP
                //use file_upload_parser.php from above url
                ajax.send(formdata);
            }
        }

        function progressHandler(event) {
            console.log("Uploaded " + event.loaded + " bytes of " + event.total);
            var percent = (event.loaded / event.total) * 100;
            document.getElementById('progressBar').style.width = Math.round(percent) + '%';
            console.log('status: ' + Math.round(percent) + "% uploaded... please wait");
        }

        function completeHandler(event) {
            console.log('status: ' + event.target.responseText);
            checkCVFile();
        }

        function errorHandler() {
            console.log("Upload Failed");
        }

        function abortHandler() {
            console.log("Upload Aborted");
        }

        uploadFile();
    }

    /*FORM SENDING*/

    function applicationFormSend() {
        let form = document.querySelector('.application-form');
        let submitBtn = form.querySelector('.submit-btn');
        let submitBtnText = form.querySelector('.submit-btn span');
        let buttonText = submitBtnText.innerText;
        let confirmMessage = document.querySelector('.confirm-message');

        if (form) {
            if (validationStatus) {
                submitBtn.classList.add('load');
                submitBtnText.innerText = 'Loading...';
                let fileCv = document.getElementById("cv").files[0];
                let request = new XMLHttpRequest();

                let data = new FormData(form);
                data.append("cv", fileCv);
                request.open("POST", "/api/application-handler.php");
                request.send(data);

                request.onload = function () {
                    submitBtn.classList.remove('load');
                    submitBtnText.innerText = buttonText;
                    if (request.status === 200) {
                        document.querySelector('[name=last-name]').value = '';
                        form.reset();
                        cvInputInner.innerHTML = cvInputInnerHTML;
                        document.getElementById('progressBar').style.width = 0;
                        showConfirmBlock();
                        setTimeout(function () {
                            confirmMessage.style.opacity = '0';
                        }, 2000)
                    } else {
                        console.log("form send failed");
                        console.log(request.response);
                        confirmMessage.innerHTML = request.response;
                        confirmMessage.style.color = 'red';
                        confirmMessage.style.opacity = '1';
                    }
                };
            }
        }
    }

    function showConfirmBlock() {
        console.log('confirm');
        let formWrap = document.querySelector('.application-form-wrap');
        formWrap.classList.add('confirm');
        window.scrollTo(0, 0);
    }
};
